<template>
    <div class="row">
        <div class="col-12">
            <VueSignaturePad
                class="pad border border-primary rounded d-block"
                ref="signaturePad"
                height="400px"
                width="100%"
                :options="options"
            />
        </div>
        <slot name="error"/>
        <div class="col-12 d-flex flex-row justify-content-between mt-1">
            <button
                class="btn btn-primary"
                @click.prevent="onFinish"
                :disabled="saved"
            >{{ $t('button.finish') }}</button>
            <ResetButton @click.prevent="onReset" />
        </div>
    </div>

</template>

<script setup lang="ts">
import ResetButton from "@/components/buttons/ResetButton.vue";
import {ref} from "vue";

const emitter = defineEmits<{
    (e: 'update:modelValue', value: string)
}>()

const { modelValue } = defineProps<{
    modelValue: string
}>()

const options = {
    penColor: '#00f'
}

const saved = ref(false)
const signaturePad = ref(null)

const onReset= () => {
    signaturePad.value.clearSignature()
    saved.value = false
    emitter('update:modelValue', null)
}
const onFinish= () => {
    const {isEmpty, data} = signaturePad.value.saveSignature();
    if (!isEmpty) {
        emitter('update:modelValue', data)
        saved.value = true
    }
}
</script>

<style scoped>
    .pad {
        max-height: 400px;
    }
</style>
